import {
    initialState,
    Actions,
    State,
    REFRESH_TOKEN,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_ERROR,
    RESET_REFRESH_TOKEN,
    LOGOUT,
    SET_TOKEN,
    REFRESH_TOKEN_EXPIRATION_CHECK
  } from '../types/auth';
  
  export default function authReducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case REFRESH_TOKEN:
            return {
              data: state.data,
              states: {
                loading: true,
                success: false,
                error: false,
              },
            };
        case REFRESH_TOKEN_SUCCESS:
            return {
                data: action.payload,
                states: {
                    loading: false,
                    success: true,
                    error: false,
                },
            };
        case REFRESH_TOKEN_ERROR:
            return {
                data: null,
                states: {
                    loading: false,
                    success: false,
                    error: action.payload,
                },
            };
        case RESET_REFRESH_TOKEN:
            return initialState;
        case SET_TOKEN:
            return {
                data: null,
                states: {
                    loading: false,
                    success: true,
                    error: false,
                },
            };
        case REFRESH_TOKEN_EXPIRATION_CHECK:
            return {
                data: null,
                states: {
                    loading: true,
                    success: false,
                    error: false,
                },
            };
        case LOGOUT:
            return { 
                data: null,
                states: {
                    loading: false,
                    success: true,
                    error: false,
                }
            };
        default:
            return state;
    }
  }
